import { render, staticRenderFns } from "./BaseWysiwyg.vue?vue&type=template&id=15201039&"
import script from "./BaseWysiwyg.vue?vue&type=script&lang=js&"
export * from "./BaseWysiwyg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports